'use client';

import React from 'react';

import { Box } from '@mui/material';
import { useTranslations, useLocale } from 'next-intl';

import ArticleItem from '@/ui/components/ArticleItem';
// import LazyLoader from '@/ui/components/LazyLoader';
import { descriptionCute } from '@/utils/helpers';
import { urlBuilder } from '@/utils/urlBuilder';

interface LazyArticlesProps {
  initialArticles: ArticleData[];
  productSlug: string;
  categorySlug: string;
  // articlesPerPage: number;
}

const LazyArticles: React.FC<LazyArticlesProps> = ({
  initialArticles,
  // productSlug,
  // categorySlug,
  // articlesPerPage,
}) => {
  // const [articles, setArticles] = useState<ArticleData[]>(initialArticles);
  // const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(false);
  // const [hasMore, setHasMore] = useState(
  //   initialArticles.length === articlesPerPage
  // );
  const locale = useLocale();
  const translate = useTranslations();

  // const fetchMoreArticles = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const nextPage = page + 1;
  //     const response = await fetch(
  //       `/api/v1/helps?locale=${locale}&page=${nextPage}&per_page=${articlesPerPage}&popular=true&product=${productSlug}&category=${categorySlug}`
  //     );
  //     const result = await response.json();

  //     const newArticles = Array.isArray(result.data)
  //       ? result.data
  //       : Array.isArray(result.data.articles)
  //       ? result.data.articles
  //       : [];

  //     if (newArticles.length === 0) {
  //       setHasMore(false);
  //     } else {
  //       setArticles(prev => [...prev, ...newArticles]);
  //       setPage(nextPage);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching more articles:', error);
  //   }
  //   setLoading(false);
  // }, [page, locale, productSlug, categorySlug]);

  return (
    <Box>
      {initialArticles.map((article, index) => (
        <ArticleItem
          key={article.id}
          href={urlBuilder({ item: article, locale })}
          imgSrc={article.media.image.thumbnail}
          imgAlt={article.title}
          title={article.title}
          description={descriptionCute(article.content)}
          buttonLabel={translate('articleList-button-article')}
          buttonIcon="file-lines"
          compact={index > 2}
        />
      ))}

      {/* {hasMore && (
        <>
          <LazyLoader
            onLoadMore={fetchMoreArticles}
            loading={loading}
            hasMore={hasMore}
          />

          <Box mt={2} textAlign="center">
            <Button
              onClick={fetchMoreArticles}
              disabled={loading}
              variant="outlined"
            >
              {loading
                ? translate('loading') || 'Loading...'
                : translate('load-more') || 'Load More'}
            </Button>
          </Box>
        </>
      )} */}
    </Box>
  );
};

export default LazyArticles;
